import React from 'react';
import './Help.css';

const Help = () => {
    return (
        <section className="help">
            <div className="help-container">
                <h2>We're here to help</h2>
                <p>Support is just a few taps away. Get your questions answered by using our help library.</p>
                <a href="#!">Get help &rarr;</a>
            </div>
        </section>
    );
};

export default Help;